import * as envSsm from 'env-ssm';
import React from 'react';
import PropTypes from 'prop-types';
// import withStyles from 'isomorphic-style-loader/lib/withStyles';
import normalizeCss from 'normalize.css';
import Modal from 'react-modal';
import MDSpinner from 'react-md-spinner';

// import s from './layout.css';
import s from './layout.css';
import Header from '../Header/header.jsx';
import Footer from '../Footer/footer.jsx';

// console.log('s', s);

const CrossLoggerPlugin = require('cross-logger-plugin');

const logger = new CrossLoggerPlugin(
  `App:${__filename.replace(__dirname, '')}`,
);

class Layout extends React.Component {
  static propTypes = {
    context: PropTypes.object.isRequired,
    children: PropTypes.element.isRequired,
  };

  constructor(props) {
    super(props);

    // ----------------------------
    // initializeData
    // ----------------------------
    const { initializeData } = this.props.context;
  }

  render() {
    const { initializeData } = this.props.context;
    const { context } = this.props;

    const childProps = {
      initializeData,
      context,
    };

    const childrenWithProps = React.Children.map(this.props.children, child =>
      React.cloneElement(child, childProps),
    );
    // console.log(childrenWithProps)
    return (
      <div style={{ height: '100%' }}>
        <Header context={context} />
        <div style={{ height: '100%' }}>{childrenWithProps}</div>
        <Footer context={context} />
      </div>
    );
  }
}

export default Layout;
